import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';
import store from '@/store'

import Main from '@/views/main/Index';

export default {
  path: 'main',
  component: Main,
  name: 'dashboard-main',
  meta: { title: 'Main' },
}
